import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import LogoutHandler from './components/auth0/LogoutHandler';
import { setAuth } from './redux/authSlice';
import RouteWrapper from './routes/RouteWrapper';
import { showToast } from './redux/toasterSlice';
import ReactGA from 'react-ga4';

function App() {
  const dispatch = useDispatch();
  const { user, logout } = useAuth0();

  useEffect(() => {
    dispatch(setAuth({ name: user?.name, email: user?.email }));
    if (user && !user?.email.includes('@monotype.com')) {
      ReactGA.initialize('G-VBJP4W2TQF');
      ReactGA.send('pageview'); // For initial page load
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('utm_campaign') != null) {
        ReactGA.set({ userId: urlParams.get('utm_campaign') });
        localStorage.setItem('guid', urlParams.get('utm_campaign'));
      }
      if (window.clarity) {
        window.clarity('identify', urlParams.get('utm_campaign'));
      }
    }
  }, [user]);

  // useEffect(() => {
  //   const checkForUser = async () => {
  //     try {
  //       // Check if the token is expired
  //       if (user?.email.includes("subrat")) {
  //         showToast("User expired. Logging out...", "error");
  //         logout({
  //           logoutParams: {
  //             returnTo: window.location.origin,
  //           },
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error decoding token or checking expiration:", error);
  //     }
  //   };
  //   checkForUser();
  // },[user])

  return (
    <>
      <RouteWrapper />
      <LogoutHandler />
    </>
  );
}
export default App;
